import { calc } from 'csx';
import { type Styles } from 'react-modal';
import { type CSSProperties } from 'typestyle/lib/types';
import { auto } from '@popperjs/core';
import StyleConstants from '../../../core/styles.constants';

export const modalStyle = (isMobile?: boolean, width?: number, overflow?: string): Styles => ({
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.25)',
    overflow: overflow ?? auto,
    borderRadius: 8,
    width: width ?? 392,
    maxWidth: isMobile ? calc('100% - 30px') : undefined,
    maxHeight: calc('100% - 30px'),
    backgroundColor: StyleConstants.WHITE_COLOR,
  },
});

export const modalBody = (isMobile?: boolean): CSSProperties => ({
  padding: isMobile ? 0 : 24,
  wordBreak: 'break-word',
  maxHeight: '75%',
  maxWidth: '100%',
});

export const modalText: CSSProperties = {
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  color: StyleConstants.GREY_COLOR,
};

export const columnHeader = (isMobile: boolean, marginBottom?: number): CSSProperties => ({
  wordBreak: 'break-word',
  textAlign: isMobile ? 'center' : undefined,
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  marginBottom,
});

export const error: CSSProperties = {
  color: StyleConstants.PINK_COLOR,
  marginTop: 12,
};

export const button: CSSProperties = {
  marginTop: 24,
};

export const deleteIcon: CSSProperties = {
  marginLeft: 8,
  height: 24,
  width: 24,
};

export const deleteButton: CSSProperties = {
  marginTop: 24,
  width: 200,
  cursor: 'pointer',
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.PINK_COLOR,
};

/**
 * A body line that costs somebody something. Same shape as {@link bodyText} and bolder, in the
 * colour this modal already uses for its error line — the point is that it reads differently from
 * the counts around it, not that it shouts.
 */
export const warningText: CSSProperties = {
  marginBottom: 8,
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.PINK_COLOR,
};

export const bodyText: CSSProperties = {
  marginBottom: 8,
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const emptyListMessage: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const gridRow: CSSProperties = {
  marginTop: 12,
};

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

export const switchBoxShadow = '0px 1px 5px rgba(0, 0, 0, 0.6)';
export const switchActiveBoxShadow = '0px 0px 1px 10px rgba(0, 0, 0, 0.2)';
export const switchHeight = 10;
export const switchWidth = 24;
export const switchDiameter = 15;

export const calendar: CSSProperties = {
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  padding: 16,
  border: '0px',
};
